export enum MSolutionType {
  Impact=-1,
  Categorization=-1,
  ReferenceScenario = 1,
  TargetScenario = 2,
  OptionA = 3,
  OptionB = 4,
  OptionC = 5,
  Actuals = 6,
}